import React, { FC } from 'react'
import "./currentStudentRank.scss";
import { Skeleton } from 'antd';
import faker, { fake } from "faker"
import PointsIcon from "../../../../../../../assets/icons/points.svg";
import { InstituteLeaderboard } from '../../../../../../../models/InstituteModel/leaderboard.model';
import PlaceholderIcon from "../../../../../../../assets/placeholder/placeholder.svg";

interface CurrentStudentRankProps {
    data: InstituteLeaderboard
    loading: boolean
}

const CurrentStudentRank: FC<CurrentStudentRankProps> = (props) => {
    const { data, loading } = props;

    return (
        <div className="current-student-rank__container">
            <div className="current-student-rank__left">
                {loading
                    ? <Skeleton.Avatar size={'large'} active></Skeleton.Avatar>
                    : <>
                        <img className="current-student__image" src={PlaceholderIcon} />
                        <div className="current-student-rank__wrapper">
                            <p className="current-student-rank__label">Your Rank</p>
                            <p className="current-student__rank">{data?.currentStudentRank || "-"}</p>
                        </div>
                    </>
                }
            </div>
            <div className="current-student-rank__right">
                {loading
                    ? <Skeleton.Avatar size={'large'} active></Skeleton.Avatar>
                    : <>
                        <p>{data?.currentStudentPoint || "No"} points</p>
                        <img src={PointsIcon} />
                    </>
                }
            </div>
        </div>
    )
}

export default CurrentStudentRank;